import { BaseModel, RecursivePartial } from '@models/base';

export class NameValue extends BaseModel {
    name?: string;
    value: any;

    constructor(json?: RecursivePartial<NameValue>) {
        super(json);
        this.parseNameValue(json || {});
    }

    parse(json: RecursivePartial<NameValue>): NameValue {
        super.parse(json);
        this.parseNameValue(json);
        return this;
    }

    private parseNameValue(json: RecursivePartial<NameValue>): void {
        NameValue.assignFields<NameValue>(this, json, ['name', 'value']);
    }
}
